import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { ISubcontractFormValues } from "../../interface/subcontract";
import { normalizeMonths } from "../../components/function/normalizeMonths";

export const addUpdateSubcontract = async (
    token: string,
    values: ISubcontractFormValues,
    forecastId: string,
    version: number,
    setOpenModal: Function,
    dispatch: Function,
    setError: Function,
    subcontractId? : string
) => {
  const normalizedValues = {
    ...values,
    months: normalizeMonths(values.months)
  };
    try {
        if(!subcontractId){

          console.log("subcontractvalue", normalizedValues);

          const response = await axios.post(`${urlAPI}/forecast/subcontract/add`,
            { ...normalizedValues, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } 
        else{
          console.log("subcontractvalue", values);

          const response = await axios.post(`${urlAPI}/forecast/subcontract/update/${subcontractId}`,
            { ...normalizedValues, forecastId, forecastVersion: version },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        }       
        setOpenModal(false);
        dispatch(showSnackbar("Frais de sous-traitance enregistré avec succès.", "success"));
      } catch (error: any) {
        if (error.response) {
          console.error("Erreur API :", error.response.data);
          console.error("Statut :", error.response.status);
        } else if (error.request) {
          console.error("Erreur de requête :", error.request);
        } else {
          console.error("Erreur :", error.message);
        }
  
        setError("Impossible d'enregistrer la sous-traitance'. Veuillez réessayer.");
        dispatch(showSnackbar("Erreur lors de l'enregistrement.", "error"));
      }
};
